/**
 * Formats an ISO / parseable date as `YYYY.MM.DD.` for the document library table.
 *
 * @returns The result of this operation.
 * @param value The value value.
 */
export function formatDocumentUploadedAt(value: Date | string): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}.`;
}
